import { ChiptaElement, html, css } from 'chipta-libs/main.js';
import { cssThemeData } from 'chipta-libs/utils/theme-data.js';
import { stripLangFromPath } from 'chipta-libs/utils/url.js';
import { csrfHiddenInput } from 'chipta-libs/snippets/csrf-hidden-input.js';
import 'chipta-libs/components/country-flag.js';
import './outside-click.js';


class LanguageSwitch extends ChiptaElement {

  static get properties() {
    return {
      showMenu: {type: String}
    };
  }

  render() {
    return html`
      <outside-click @outside-click=${this.hideMenu}>
        <div>${this.activeLanguageEl}</div>
        <div id="other-languages" ?show=${this.showMenu}>
          ${this.otherLanguageEls}
        </div>
      </outside-click>
    `;
  }

  get activeLanguageEl() {
    return html`
      <div class="language" @click=${() => this.toggleMenu()}>
        <country-flag countryCode=${jsVar('language')}></country-flag>
        <span>${jsVar('language')}</span>
      </div>
    `;
  }

  get otherLanguageEls() {

    const els = [];

    for (let language of jsVar('languageCodes')) {
      if (language === jsVar('language')) continue;
      els.push(
        this.getLangEl(
          language,
          () => this.switchToLang(language)
        )
      );
    }

    return els;

  }

  getLangEl(language) {
    return html`
      <form action="/i18n/setlang/" method="POST">
        ${csrfHiddenInput()}
        <input type="hidden" name="language" value=${language}></input>
        <input type="hidden" name="next" value=${this.nextUrl(language)}></input>
        <button class="language">
          <country-flag countryCode=${language}></country-flag>
          <span>${language}</span>
        </button>
      </form>
    `;
  }

  nextUrl(language) {
    return (
      '/' + language + '/'
      + stripLangFromPath(window.location.pathname)
      + window.location.search
    );
  }

  toggleMenu() {
    this.showMenu = !this.showMenu;
  }

  hideMenu() {
    this.showMenu = false;
  }

  switchToLang(language) {
    const currentUrl = window.location.href;
    // TODO: only replace when match is at start of URL path
    window.location.href = currentUrl.replace('/' + jsVar('language') + '/', '/' + language + '/');
  }

  static get styles() {
    return css`

      :host {
        display: block;
      }

      * {
        box-sizing: border-box;
      }

      #other-languages {
        display: none;
        position: absolute;
        left: 0;
      }

      #other-languages[show] {
        display: block;
        background: white;
        ${cssThemeData('language_switch.other_languages')};
      }

      .language {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0;
        padding: 5px 10px;
        background: none;
        border: none;
        cursor: pointer;
        text-transform: uppercase;
        ${cssThemeData('language_switch.language')};
      }

      country-flag {
        display: inline-block;
        width: 13px;
        height: 10px;
        ${cssThemeData('language_switch.country_flag')};
      }

      @media screen and (max-width: 500px) {

        .language {
          padding: 10px 15px;
        }

      }

    `;
  }
}

customElements.define('language-switch', LanguageSwitch);

export { LanguageSwitch };
